import { useTimer } from 'react-timer-hook';
import { A } from '../../../../../hybrid/wrappers';
import T, { t } from '../../../../../common/components/T';
import { useContext } from 'react';
import { LangContext } from '../../../../../common/decorators/Language';
import css from './Timer.module.scss';

const Timer = ({ time, onExpire }) => {
    const { translation } = useContext(LangContext) || {};

    const { seconds, minutes } = useTimer({
        expiryTimestamp: time,
        onExpire
    });

    return (
        <div className={css.authHeadingRepeatTimer}>
            <p className={css.authHeadingRepeatTimerError}>
                <T textName='confirm-auth-timer' defaultStr='Вы можете отправить письмо повторно через' page='/authentication' />{' '}
                {`${minutes}`.length > 1 ? '' : '0'}
                {minutes}:{`${seconds}`.length > 1 ? '' : '0'}
                {seconds}.
            </p>
            <p className={css.authHeadingRepeatTimerText}>
                <T
                    textName='confirm-auth-timer-2'
                    defaultStr='Не получили email? Свяжитесь с нами на странице'
                    page='/authentication'
                />{' '}
                <A href={`/contact`} className={css.authHeadingRepeatTimerLink}>
                    {t('contact-link', 'Контакты', '/authentication', translation)}
                </A>
                .
            </p>
        </div>
    );
};
export default Timer;
